<template>
  <div class="row">
    <div class="col-lg-4 offset-lg-4 pb-1 pb-lg-0">
      <a
        :href="pdfDownloadPath"
        type="button"
        class="btn btn--white border bg-white"
        v-show="pdfDownloadPath"
        download="BinCollectionScheduleDoc.pdf"
        ><span class="pr-2"><i class="icon icon-ourservices"></i></span>Download
        as PDF</a
      >
    </div>
    <div class="col-lg-4">
      <a
        :href="icsBlobPath"
        v-show="icsBlobPath"
        download="BinCollectionSchedule.ics"
        type="button"
        class="btn btn--white border bg-white"
        ><span class="pr-2"><i class="icon icon-calendar"></i></span>Download to
        Calendar</a
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fileDLAttach: [String, Object],
    icsBlobPath: String,
  },
  data() {
    return {
      filePath: process.env.MIX_APP_URL,
      pdfBlob: null,
    };
  },
  computed: {
    hasPdfDownload() {
      return this.fileDLAttach && this.fileDLAttach.download_link;
    },
    pdfDownloadPath() {
      return this.pdfBlob ? window.URL.createObjectURL(this.pdfBlob) : "";
    },
    pdfPath() {
      return this.filePathReal + this.fileDLAttach.download_link;
    },
    filePathReal() {
      return this.filePath.indexOf("storage") === -1
        ? `${this.filePath}/storage/`
        : this.filePath;
    },
  },

  mounted() {
    //Readjust data fetching of pdf file
    if (this.pdfPath && !this.pdfBlob && this.hasPdfDownload) {
      let self = this;
      fetch(this.pdfPath)
        .then((response) => response.blob())
        .then((response) => {
          const blob = new Blob([response], { type: "application/pdf" });
          self.pdfBlob = blob;
        });
    }
  },
};
</script>